import React, {Component} from 'react'
import FilterTooltip from "./FilterTooltip";
import PaginationFilterTooltip from "./PaginationFilterTooltip";


class TheadPaginationComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filterData: []
        }

    }

    getFilteredData = (field) => {
        let language = localStorage.getItem('language')
        let statuses = this.props.statuses
        switch (field) {

            case "IsLicense": {
                return [language === "he" ? "כן" : "Yes",
                    language === "he" ? "לא" : "No"]
            }
            case "choose_programm": {
                return [language === "he" ? "הוצאת רישיון חדש" : "New medical cannabis permit",
                    language === "he" ? "חידוש רישיון למטופלים קיימים" : "Renew medical cannabis permit",
                    language === "he" ? "חידוש רישיון למטופלים חדשים" : "License renewal for new patients",
                    language === "he" ? "הוצאת מרשם חדש" : "New medical cannabis Prescription",
                    language === "he" ? "חידוש מרשם למטופלים קיימים" : "Renew medical cannabis Prescription",
                    language === "he" ? "חידוש מרשם למטופלים חדשים" : "Prescription renewal for new patients"]
            }
            case "resourceName": {
                return ["לאומית", "איכילוב", "ללא"
                ]
            }

            case "requestStatus": {
                return statuses.map(item => {
                    return language === "he" ? item.status_desc_he : item.status_desc
                })
            }
            case "insurance": {
                return [language === "he" ? "מכבי" : "Maccabi",
                    language === "he" ? "כללית" : "Clalit",
                    language === "he" ? "לאומית" : "Leumit",
                    language === "he" ? "מאוחדת" : "Meuhedet",
                    language === "he" ? "חברת ביטוח" : "Insurance company",
                    language === "he" ? "צה\"ל" : "IDF",
                    language === "he" ? "משרד הביטחון" : "Ministry of Defence",
                    language === "he" ? "ללא ביטוח" : "No Insurance",
                    language === "he" ? "רשות פלסטינאית" : "The Palestinian Authority",
                    language === "he" ? "אחר" : "Other"]
            }

            default:
                return []

        }

    }

    orderFunction = (event, key) => {
        localStorage.setItem('currentPage', 0)
        this.props.onOderByTable(key)
        this.props.toggleSort(event)

    }

    render() {

        let style = {
            cursor: 'initial',
            ...this.props.style
        }
        let labelStyle = {
            cursor: 'pointer',
            ...this.props.children[0].props.className
        }
        let filterStyle = {
            width: '12px',
            height: '12px',
        }
        let makeFilter = !!this.props.makeFilter
        let thClass = this.props.thClass ? this.props.thClass : ""
        let inClassName = this.props.children[0].props.className ? this.props.children[0].props.className : ""
        let filterData = this.getFilteredData(this.props.field)

        return (
            <div className={`rt-th ${this.props.className}`} role={this.props.role} tabIndex={this.props.tabIndex}
                 style={style}>

                <div onClick={e => this.orderFunction(e, this.props.children[0].props.children)} style={labelStyle}
                     className={`${thClass} ${inClassName}`}>{this.props.children[0].props.children}</div>
                {
                    makeFilter &&
                    <PaginationFilterTooltip field={this.props.field}
                                             filterStyle={filterStyle}
                                             TabView={this.props.TabView}
                                             filterData={filterData}
                                             filterConverter={this.props.filterConverter}
                                             onFilterDataSelected={filter => this.props.onFilterDataSelected(filter)}/>
                }
            </div>

        )
    }
}

export default TheadPaginationComponent;

